import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "language", "id", "name", "description", "thumbnailSquareUrl", "thumbnailRectangleUrl", "itemsCount", "deletedAt"];
export function playlistToPlaylistCardModel(playlist, progress = null) {
  const {
      type,
      language,
      id,
      name,
      description,
      thumbnailSquareUrl,
      thumbnailRectangleUrl,
      itemsCount,
      deletedAt
    } = playlist,
    otherProps = _objectWithoutPropertiesLoose(playlist, _excluded);
  const languageString = (language === null || language === void 0 ? void 0 : language.toString().toUpperCase()) || 'EN';
  const commonFields = {
    playlistId: id,
    id,
    name,
    description,
    language: languageString,
    thumbnailSquareUrl: thumbnailSquareUrl || undefined,
    thumbnailRectangleUrl: thumbnailRectangleUrl || undefined,
    itemsCount,
    deletedAt: deletedAt || 0,
    previewThumbnailSquareUrl: thumbnailSquareUrl || undefined,
    previewThumbnailRectangleUrl: thumbnailRectangleUrl || undefined,
    progress
  };
  if (type === 'LEARNING_PATH') {
    return Object.assign({}, commonFields, {
      visibility: otherProps.visibility || 'PUBLIC',
      subCategories: otherProps.subCategories || [],
      active: otherProps.active || true,
      internalName: otherProps.internalName || name,
      type: 'LEARNING_PATH',
      __typename: 'com.hubspot.learning.center.playlists.core.playlist.api.internal.learningpath.pagination.SimpleLearningPathResponse'
    });
  } else {
    // Handle STANDARD playlist type
    return Object.assign({}, commonFields, {
      type: 'PLAYLIST',
      __typename: 'com.hubspot.learning.center.playlists.core.playlist.api.internal.learningpath.pagination.SimpleStandardPlaylistResponse'
    });
  }
}
export function playlistProgressToCardPlaylistProgress({
  playlistId,
  itemsProgress,
  status,
  updatedAt,
  progressLevel
}) {
  return {
    id: playlistId,
    completedItemsCount: (itemsProgress === null || itemsProgress === void 0 ? void 0 : itemsProgress.filter(item => item.status === 'COMPLETED').length) || 0,
    updatedAt: updatedAt || 0,
    type: 'PLAYLIST',
    status,
    hidden: false,
    completedPercentage: progressLevel || 0,
    remainingDuration: 0,
    // not used
    __typename: 'com.hubspot.userprogress.bff.rpc.models.PlaylistProgressResponse'
  };
}
export const maybePlaylistCardModelWithProgress = (playlist, progress) => playlist && playlistToPlaylistCardModel(playlist, progress && playlistProgressToCardPlaylistProgress(progress));